import styled from '@emotion/styled';
import { gridSize } from '@atlaskit/theme/constants';
import { N900 } from '@atlaskit/theme/colors';
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
export const FilterColLabText = styled.span({
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  width: `${gridSize() * 22}px`,
  paddingLeft: "var(--ds-space-050, 4px)",
  color: `var(--ds-text, ${N900})`
});